// extracted by mini-css-extract-plugin
export default {"main":"URyys2","isReply":"ZzYhKE","avatar":"QqDoCk"};